import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";

export default function TermsOfServicePage() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="1st Jan 2026">
      <p>
        Welcome to this WhatsApp-based reminder assistant. By using the service,
        you agree to these Terms of Service (“Terms”). If you do not agree,
        please do not use the service.
      </p>

      <section>
        <h2 className="text-xl font-bold text-slate-900">1. Description of Service</h2>
        <p className="mt-2">
          The service allows users to create, update, delete, and list reminders
          through WhatsApp messages (e.g., “Remind me to wash clothes at 5 PM”).
          The service sends reminder notifications to users at the scheduled time via
          WhatsApp.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">2. Eligibility</h2>
        <p className="mt-2">
          You must be at least 13 years old (or the minimum age required by your
          local laws) to use the service.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">3. User Responsibilities</h2>
        <p className="mt-2">You agree to:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>Provide accurate reminder information</li>
          <li>Use the service only for lawful purposes</li>
          <li>Not misuse or attempt to disrupt the service</li>
        </ul>
        <p className="mt-2">
          The service is not responsible for missed reminders caused by incorrect
          input, WhatsApp delivery issues, or technical failures beyond our
          control.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">4. Service Availability</h2>
        <p className="mt-2">
          The service is provided on an “as is” and “as available” basis. We do not
          guarantee uninterrupted or error-free service.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">5. Termination</h2>
        <p className="mt-2">
          We reserve the right to suspend or terminate access to the service if these
          Terms are violated or if required by law.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">6. Changes to Terms</h2>
        <p className="mt-2">
          We may update these Terms at any time. Continued use of the service after
          changes constitutes acceptance of the updated Terms.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">7. Contact</h2>
        <p className="mt-2">For questions regarding these Terms, contact:</p>
        <p className="mt-2">
          <a
            href="mailto:prakharpandedevwork@gmail.com"
            className="text-blue-600 hover:text-blue-700 font-semibold"
          >
            prakharpandedevwork@gmail.com
          </a>
        </p>
      </section>
    </LegalPageLayout>
  );
}


